export const RefriKey = {
  EMISSION_SOURCE: 'emissionSource',
  NO_UNITS: 'numberOfUnit',
  REFRI_USED: 'refrigerantUsed',
  FREQUENCY_INSPE: 'frequencyOfInspections',
  FREQUENCY_NO: 'frequencyNumber',
  REFRI_CHARGE: 'refrigerantCharge',
  DATE_INSTALLATION: 'dateOfInstallation',
  DATE_UNINSTALLATION: 'dateOfUninstallation',
  QUANTITY_TF: 'quantity',
  STATUS: 'status',
  COMMENT: 'comment'
};

export const RefriLabel = {
  EMISSION_SOURCE: 'Type of Equipment',
  NO_UNITS: 'No. of Units',
  REFRI_USED: 'Refrigerant Used',
  FREQUENCY_INSPE: 'Frequency of Inspections',
  FREQUENCY_NO: 'Frequency Number',
  REFRI_CHARGE: 'Total Refrigerant Charge',
  DATE_INSTALLATION: 'Date of Installation',
  DATE_UNINSTALLATION: 'Date of Uninstallation',
  QUANTITY_TF: 'Quantity',
  STATUS: 'Status',
  COMMENT: 'comment',
  STATUS_COMMENTS: 'Status & Comments'
};

export const RefriTooltip = {
  REFRI_USED:
    'Select the refrigerant type used in all selected units/devices.',
  FREQUENCY_INSPE:
    'Enter the inspection frequency applicable to all selected units/devices.',
  REFRI_CHARGE:
    'Enter the total refrigerant charge for all selected units/devices.'
};
